/**
 * Footer — keep nav accordions open on desktop; collapsible on mobile.
 */
(function () {
  var MQ = '(min-width: 750px)';

  function syncAccordions(root) {
    var mq = window.matchMedia(MQ);
    var nodes = (root || document).querySelectorAll('[data-footer-accordion]');
    nodes.forEach(function (el) {
      if (mq.matches) {
        el.setAttribute('open', '');
        el.dataset.desktopOpen = 'true';
      } else if (el.dataset.desktopOpen === 'true') {
        el.removeAttribute('open');
        delete el.dataset.desktopOpen;
      }
    });
  }

  function init() {
    var footer = document.querySelector('[data-mc-footer]');
    if (!footer) return;
    syncAccordions(footer);

    var mq = window.matchMedia(MQ);
    if (mq.addEventListener) {
      mq.addEventListener('change', function () {
        syncAccordions(footer);
      });
    } else if (mq.addListener) {
      mq.addListener(function () {
        syncAccordions(footer);
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    if (event.target.querySelector('[data-mc-footer]') || event.target.matches('[data-mc-footer]')) {
      syncAccordions(event.target);
    }
  });
})();
